import React from 'react';
import { motion } from 'framer-motion';
import VideoPlayer from '../VideoPlayer';

const Features: React.FC = () => {
  return (
    <section id="features" className="features-video-section">
      <div className="container">
        <div className="features-video-header">
          <motion.span 
            className="showcase-badge"
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            colorcache
          </motion.span>
          <motion.h2 
            className="features-video-title"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, margin: "-100px" }}
          >
            No More Digging
          </motion.h2>
          <motion.p 
            className="features-video-description"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
            viewport={{ once: true, margin: "-100px" }}
          >
            ColorCache puts everything you need in one place: HEX/RGB codes, brand logos, and font names. Export your collections and share them with your team to keep everyone on brand.
          </motion.p>
        </div>
        
        <motion.div 
          className="demo-video-container"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
          viewport={{ once: true, margin: "-100px" }}
        >
          <VideoPlayer videoId="1148503290" />
        </motion.div>
      </div>
    </section>
  );
};

export default Features;
